import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getTeams } from "api/Settings";


interface FiltersProps {
    search?: string,
    date_of_creation?: string,
    status?: string
    type?: string
}
export const useTeams = (filters?: FiltersProps) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['teams', filters?.search, filters?.date_of_creation, filters?.status, filters?.type],
        () => {
            return getTeams({
                search: filters?.search,
                date_of_creation: filters?.date_of_creation,
                status: filters?.status,
                type: filters?.type
            });
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },

    });

    return {
        data,
        isLoading,
    };
};
